var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBestSellingGoods(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F9ECD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1524 4.29616L12.3256 6.66196C12.4856 6.99129 12.9122 7.30717 13.2722 7.36766L15.3986 7.72388C16.7585 7.95239 17.0784 8.9471 16.0985 9.92837L14.4454 11.5952C14.1654 11.8775 14.0121 12.4219 14.0987 12.8117L14.572 14.875C14.9453 16.5082 14.0854 17.14 12.6522 16.2865L10.6591 15.0968C10.2992 14.8818 9.7059 14.8818 9.33928 15.0968L7.34616 16.2865C5.91965 17.14 5.05308 16.5015 5.42637 14.875L5.89966 12.8117C5.98631 12.4219 5.833 11.8775 5.55303 11.5952L3.89988 9.92837C2.92665 8.9471 3.23995 7.95239 4.5998 7.72388L6.72623 7.36766C7.07953 7.30717 7.50614 6.99129 7.66613 6.66196L8.83933 4.29616C9.47926 3.01245 10.5191 3.01245 11.1524 4.29616Z",
    stroke: "#AC6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBestSellingGoods);
export default __webpack_public_path__ + "static/media/icon-best-selling-goods.a6eedfda4ac69a7d4969b5eec3279f7b.svg";
export { ForwardRef as ReactComponent };